/**
 * Stufic ürün sayfası davranışları: galeri, sekmeler, SSS, video ve
 * ölçüye özel konfigüratör.
 *
 * Birimler: in / ft+in / cm (üçlü seçici). İç hesap her zaman cm;
 * müşteri girdiği orijinal birimde görür (Size property), üretim gizli
 * property'lerde cm alır (_Size, _Print size).
 *
 * Fiyat modeli: varyant fiyatı 0,1 m² başınadır; adet = alan(m²) × 10,
 * en az minimum sipariş alanı (min_area_m2) kadar faturalanır.
 *
 * Kırpma: çerçeve duvar oranında, görsele sığan en büyük boyutta, tek
 * eksende kayar; üretime görsel yüzdesi olarak gider (_Crop area %).
 */
(function () {
  'use strict';

  var CM_PER_IN = 2.54;
  var SQFT_PER_M2 = 10.7639;

  /* ---------- galeri ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main] img');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
        if (btn.dataset.full) {
          main.src = btn.dataset.full;
          main.removeAttribute('srcset');
        }
      });
    });
  }

  /* ---------- sekmeler + SSS + video ---------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
        panels.forEach(function (p) { p.hidden = p.dataset.panel !== tab.dataset.tab; });
      });
    });

    root.querySelectorAll('[data-faq-q]').forEach(function (q) {
      q.addEventListener('click', function () {
        var answer = q.nextElementSibling;
        var open = answer.hidden;
        root.querySelectorAll('.faq__a').forEach(function (a) { a.hidden = true; });
        root.querySelectorAll('[data-faq-q]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          b.querySelector('.sign').textContent = '+';
        });
        if (open) {
          answer.hidden = false;
          q.setAttribute('aria-expanded', 'true');
          q.querySelector('.sign').textContent = '–';
        }
      });
    });

    var play = root.querySelector('[data-tabs-play]');
    var video = root.querySelector('[data-tabs-video]');
    if (play && video) {
      play.addEventListener('click', function () {
        video.hidden = false;
        video.controls = true;
        video.play();
        play.hidden = true;
      });
    }

    /* malzeme fotoğrafı lightbox'ı */
    var zoomDialog = root.querySelector('[data-mat-zoom-dialog]');
    if (zoomDialog) {
      var zoomImg = zoomDialog.querySelector('img');
      root.querySelectorAll('[data-mat-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          zoomImg.src = btn.dataset.matZoom;
          zoomDialog.showModal();
        });
      });
      zoomDialog.querySelector('[data-mat-zoom-close]').addEventListener('click', function () {
        zoomDialog.close();
      });
      zoomDialog.addEventListener('click', function (e) {
        if (e.target === zoomDialog) zoomDialog.close();
      });
    }
  }

  /* ---------- konfigüratör ---------- */
  function initConfigurator(root) {
    var cfgEl = root.querySelector('[data-cfg-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var variants = JSON.parse(root.querySelector('[data-cfg-variants]').textContent);
    if (!cfg.imageUrl || !variants.length) return;

    /* ---------- renk varyantları (14 Eki 2026) ----------
       Printho renk varyantlarını aynı ürünün "Color/Renk" seçeneği olarak basar; her varyant
       JSON'unda color / colorImage / rawImage taşır. Malzeme kartları, karşılaştırma, numune
       seçimi, galeri ana görseli ve duvar aracı crop'u SEÇİLİ renge göre çalışır. Renk
       seçeneği olmayan üründe (color null) davranış değişmez. Ürün sayfası → duvar aracı
       bağlantısı seçili rengi ?color= ile taşır. */
    var allVariants = variants;
    var colors = [];
    allVariants.forEach(function (v) { if (v.color && colors.indexOf(v.color) < 0) colors.push(v.color); });
    var urlColor = null;
    try { urlColor = new URLSearchParams(location.search).get('color'); } catch (e) {}
    var activeColor = colors.length ? (colors.indexOf(urlColor) >= 0 ? urlColor : colors[0]) : null;
    function byColor() { return activeColor ? allVariants.filter(function (v) { return v.color === activeColor; }) : allVariants; }
    variants = byColor();
    function rawFor() { var v = variants[0]; return (v && v.rawImage) || cfg.imageUrl; }

    var $ = function (sel) { return root.querySelector(sel); };

    /* ---------- mağaza dili ----------
       Bu dosya iki mağazada BİREBİR aynıdır (tools/parity.mjs). Mağazaya özel olan
       yalnız metin ve para biçimi; ikisi de section'daki cfg'den (locale, currency)
       seçilir — kod çatallanmaz. Yeni metin eklerken iki dile de yazın. */
    var LANG = /^tr/i.test(cfg.locale || '') ? 'tr' : 'en';
    var L = {
      en: {
        goWait: 'Enter Width & Height',
        ph: { in: { w: 'e.g. 120', h: 'e.g. 96' }, ftin: { w: 'e.g. 10', h: 'e.g. 8' }, cm: { w: 'e.g. 300', h: 'e.g. 240' } },
        rangeFt: function (a, b, c) { return 'Enter ' + a + '–' + b + ' ft width and up to ' + c + ' ft height.'; },
        range: function (u, a, b, c, d) { return 'Enter ' + a + '–' + b + ' ' + u + ' width and ' + c + '–' + d + ' ' + u + ' height.'; },
        minOrder: 'Minimum order is [sqft] sq ft.',
        panelOne: function (w) { return '1 panel · ' + w + ' wide'; },
        panelMany: function (n, w) { return n + ' panels × ' + w; },
        panelLast: ' · last ',
        unavailable: 'Unavailable', selected: 'Selected', selectMat: 'Select this material',
        matDetails: function (t) { return t + ' details'; }, matDetailsTitle: 'Material details',
        enterSize: 'Enter Wall Size', pickMat: 'Select a Material to Continue', addToCart: 'Add to Cart',
        billedAt: function (a) { return 'Billed at ' + a; },
        billedTail: function (a) { return 'billed at ' + a; },
        youSave: function (m, p) { return 'You save ' + m + ' (' + p + '%)'; },
        estFrom: 'Estimated from',
        pSize: 'Size', pArea: 'Area', pBilling: 'Billing',
        billingMin: function (a) { return 'Minimum order — billed at ' + a; },
        pOrient: 'Orientation', mirrored: 'Mirrored (flipped)',
        pColor: 'Color', grayscale: 'Grayscale', pNote: 'Note',
        sizeInches: true
      },
      tr: {
        goWait: 'Genişlik ve Yükseklik Gir',
        ph: { in: { w: 'örn. 120', h: 'örn. 96' }, ftin: { w: 'örn. 10', h: 'örn. 8' }, cm: { w: 'örn. 300', h: 'örn. 240' } },
        rangeFt: function (a, b, c) { return 'Genişlik için ' + a + '–' + b + ' ft, yükseklik en çok ' + c + ' ft gir.'; },
        range: function (u, a, b, c, d) { return 'Genişlik için ' + a + '–' + b + ' ' + u + ', yükseklik için ' + c + '–' + d + ' ' + u + ' gir.'; },
        minOrder: 'Minimum sipariş [sqft] m².',
        panelOne: function (w) { return '1 panel · ' + w + ' en'; },
        panelMany: function (n, w) { return n + ' panel × ' + w; },
        panelLast: ' · son ',
        unavailable: 'Mevcut değil', selected: 'Seçili', selectMat: 'Bu malzemeyi seç',
        matDetails: function (t) { return t + ' detayları'; }, matDetailsTitle: 'Malzeme detayları',
        enterSize: 'Duvar Ölçünü Gir', pickMat: 'Devam için Malzeme Seçin', addToCart: 'Sepete Ekle',
        billedAt: function (a) { return a + ' üzerinden faturalanır'; },
        billedTail: function (a) { return a + ' üzerinden faturalanır'; },
        youSave: function (m, p) { return 'Kazancınız ' + m + ' (%' + p + ')'; },
        estFrom: 'Tahmini',
        pSize: 'Ölçü', pArea: 'Alan', pBilling: 'Faturalama',
        billingMin: function (a) { return 'Minimum sipariş — ' + a + ' üzerinden faturalanır'; },
        pOrient: 'Yön', mirrored: 'Aynalanmış (çevrildi)',
        pColor: 'Renk', grayscale: 'Gri ton', pNote: 'Not',
        /* TR pazarı yalnız cm kullanır — görünür ölçü satırında inch yok */
        sizeInches: false
      }
    }[LANG];

    var elUnit = $('[data-cfg-unit]');
    var elHelp = $('[data-cfg-help]');
    var elHelpM = $('[data-cfg-help-m]');
    var elMinNote = $('[data-cfg-min-note]');
    var elOpen = $('[data-cfg-open]');
    var modal = $('[data-cfg-modal]');
    var elMaterials = $('[data-cfg-materials]');
    var elBarDims = $('[data-cfg-bar-dims]');
    var elBarMat = $('[data-cfg-bar-material]');
    var elBarTotal = $('[data-cfg-bar-total]');
    var elBarHint = $('[data-cfg-bar-hint]');
    var elAdd = $('[data-cfg-add]');
    var elAddWrap = $('[data-cfg-add-wrap]');
    var elPriceWrap = $('[data-cfg-price]');
    var elPricePrefix = $('[data-cfg-price-prefix]');
    var elPriceAmount = $('[data-cfg-price-amount]');
    var elPriceCompare = $('[data-cfg-price-compare]');
    var elPriceSuffix = $('[data-cfg-price-suffix]');
    var elBarCompare = $('[data-cfg-bar-compare]');
    var elSumDims = $('[data-wt-sum-dims]');
    var elSumArea = $('[data-wt-sum-area]');
    var elSumMat = $('[data-wt-sum-mat]');
    var elSumTotal = $('[data-wt-sum-total]');
    var elSumTotalAmt = $('[data-wt-sum-total-amt]');
    var elSumTotalCmp = $('[data-wt-sum-total-cmp]');
    var elSumSave = $('[data-wt-sum-save]');
    var toolBtns = root.querySelectorAll('[data-cfg-toggle]');
    var elGoLink = $('[data-cfg-golink]');
    /* Hazır etiketi tema ayarından gelir; "bekliyor" etiketi ölçü istendiğini söyler. */
    var goLinkLabel = elGoLink ? (elGoLink.textContent || '').trim() : '';
    var goLinkWaitLabel = L.goWait;
    function setText(el, text) { if (el.textContent !== text) el.textContent = text; }
    var canvas = $('[data-cfg-crop]');
    var ctx = canvas ? canvas.getContext('2d') : null;
    var isTool = !!canvas;

    var fmtMoney, money;
    if (cfg.currency === 'TRY') {
      /* TR mağaza: mağazanın money_format'ıyla birebir ("1.250,00 TL") — Intl "₺" yazar */
      fmtMoney = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      money = function (cents) { return fmtMoney.format(cents / 100) + ' TL'; };
    } else {
      try {
        fmtMoney = new Intl.NumberFormat(cfg.locale || 'en-US', { style: 'currency', currency: cfg.currency, currencyDisplay: 'narrowSymbol' });
      } catch (e) {
        fmtMoney = new Intl.NumberFormat(cfg.locale || 'en-US', { style: 'currency', currency: cfg.currency });
      }
      money = function (cents) { return fmtMoney.format(cents / 100); };
    }

    /* değer değiştiyse yaz ve kısa tick animasyonunu tetikle */
    function setTick(el, text) {
      if (el.textContent === text) return;
      el.textContent = text;
      el.classList.remove('price-tick');
      void el.offsetWidth; // animasyonu yeniden başlat
      el.classList.add('price-tick');
    }
    var fmt1 = new Intl.NumberFormat(cfg.locale || 'en-US', { maximumFractionDigits: 1 });
    var fmt2 = new Intl.NumberFormat(cfg.locale || 'en-US', { maximumFractionDigits: 2 });

    var helpDefault = elHelp ? elHelp.innerHTML : '';
    var pickText = elBarMat ? elBarMat.textContent : '';
    var sumDimsDefault = elSumDims ? elSumDims.textContent : '';
    var sumMatDefault = elSumMat ? elSumMat.textContent : '';
    var priceDefault = elPriceWrap ? {
      prefix: elPricePrefix.textContent,
      amount: elPriceAmount.textContent,
      suffix: elPriceSuffix.textContent,
      compare: elPriceCompare ? elPriceCompare.textContent : '',
      compareHidden: elPriceCompare ? elPriceCompare.hidden : true
    } : null;

    /* sınırlar — ayarlar inch, iç hesap cm */
    var minSideCm = (cfg.minSideIn || 12) * CM_PER_IN;
    var maxWCm = (cfg.maxWidthIn || 480) * CM_PER_IN;
    var maxHCm = (cfg.maxHeightIn || 240) * CM_PER_IN;
    var minAreaM2 = cfg.minAreaM2 || 0;
    var minQty = Math.round(minAreaM2 * 10);

    var state = {
      unit: cfg.defaultUnit || 'in', wCm: 0, hCm: 0, variant: null, fx: 0, fy: 0, valid: false,
      ruler: true, panels: true, figure: true, grayscale: false, flip: false
    };
    /* toggle butonlarının başlangıç durumunu markup'taki aria-pressed belirler */
    toolBtns.forEach(function (btn) {
      state[btn.dataset.cfgToggle] = btn.getAttribute('aria-pressed') === 'true';
    });
    var layerDefaults = { ruler: state.ruler, panels: state.panels, figure: state.figure };

    /* ---------- ölçü alanları (tek kutu veya ft+in çifti) ---------- */
    /* "e.g." öneki şart: çıplak "120"/"96" girilmiş gerçek değer sanılıyordu —
       CTA "ölçü gir" derken alanlar dolu görünüyordu (çelişki). */
    var PLACEHOLDERS = L.ph;

    function makeField(el, axis) {
      return {
        el: el,
        axis: axis,
        a: el.querySelector('[data-a]'),
        b: el.querySelector('[data-b]'),
        slotB: el.querySelector('[data-slot-b]'),
        sfxA: el.querySelector('[data-sfx-a]')
      };
    }

    var fields = [];
    root.querySelectorAll('[data-cfg-field]').forEach(function (el) {
      var key = el.dataset.cfgField; // w, h, wm, hm
      var axis = key.charAt(0) === 'w' ? 'w' : 'h';
      fields.push(makeField(el, axis));
    });

    function setFieldModes() {
      var ftin = state.unit === 'ftin';
      fields.forEach(function (f) {
        f.slotB.hidden = !ftin;
        f.sfxA.textContent = ftin ? 'ft' : state.unit;
        f.a.placeholder = PLACEHOLDERS[state.unit][f.axis];
        if (f.b) f.b.placeholder = '0';
      });
    }

    /* Alanlar type="text" (type="number" değerini TARAYICI DİLİNE göre gösterir;
       tr tarayıcıda "56.1" → "56,1". US pazarı için ayraç DAİMA nokta olmalı.)
       Kullanıcı yine de virgül yazabilir → parse ederken noktaya normalize edilir. */
    function numVal(el) {
      if (!el) return 0;
      return parseFloat(String(el.value || '').replace(',', '.')) || 0;
    }

    function fieldCm(f) {
      var a = numVal(f.a);
      var b = numVal(f.b);
      if (state.unit === 'ftin') return (a * 12 + b) * CM_PER_IN;
      if (state.unit === 'in') return a * CM_PER_IN;
      return a;
    }

    function fieldTouched(f) {
      return !!(f.a.value || (f.b && f.b.value));
    }

    function setFieldFromCm(f, cm) {
      if (!cm) { f.a.value = ''; if (f.b) f.b.value = ''; return; }
      if (state.unit === 'ftin') {
        var totalIn = cm / CM_PER_IN;
        var ft = Math.floor(totalIn / 12);
        var rem = Math.round((totalIn - ft * 12) * 10) / 10;
        if (rem >= 12) { ft += 1; rem = 0; }
        f.a.value = ft;
        f.b.value = rem;
      } else if (state.unit === 'in') {
        f.a.value = Math.round((cm / CM_PER_IN) * 10) / 10;
      } else {
        f.a.value = Math.round(cm * 10) / 10;
      }
    }

    function syncFields(exceptEl) {
      fields.forEach(function (f) {
        if (f.el === exceptEl) return;
        setFieldFromCm(f, f.axis === 'w' ? state.wCm : state.hCm);
      });
    }

    /* ---------- birim etiket/format yardımcıları ---------- */
    function unitName() { return state.unit === 'cm' ? 'cm' : state.unit === 'in' ? 'in' : 'ft'; }

    function rangeText() {
      if (state.unit === 'ftin') {
        return L.rangeFt(Math.ceil(minSideCm / CM_PER_IN / 12), Math.floor(maxWCm / CM_PER_IN / 12), Math.floor(maxHCm / CM_PER_IN / 12));
      }
      if (state.unit === 'cm') {
        return L.range('cm', Math.ceil(minSideCm), Math.floor(maxWCm), Math.ceil(minSideCm), Math.floor(maxHCm));
      }
      return L.range('in', Math.ceil(minSideCm / CM_PER_IN), Math.floor(maxWCm / CM_PER_IN), Math.ceil(minSideCm / CM_PER_IN), Math.floor(maxHCm / CM_PER_IN));
    }

    function dimLabelOne(cm) {
      if (state.unit === 'ftin') {
        var totalIn = cm / CM_PER_IN;
        var ft = Math.floor(totalIn / 12);
        var rem = Math.round((totalIn - ft * 12) * 10) / 10;
        if (rem >= 12) { ft += 1; rem = 0; }
        return rem > 0 ? ft + ' ft ' + fmt1.format(rem) + ' in' : ft + ' ft';
      }
      if (state.unit === 'cm') return fmt1.format(cm) + ' cm';
      return fmt1.format(cm / CM_PER_IN) + ' in';
    }

    function dimsLabel() {
      if (state.unit === 'cm') return fmt1.format(state.wCm) + ' × ' + fmt1.format(state.hCm) + ' cm';
      if (state.unit === 'in') return fmt1.format(state.wCm / CM_PER_IN) + ' × ' + fmt1.format(state.hCm / CM_PER_IN) + ' in';
      return dimLabelOne(state.wCm) + ' × ' + dimLabelOne(state.hCm);
    }

    function areaM2() { return (state.wCm * state.hCm) / 10000; }
    function areaLabel() {
      return state.unit === 'cm' ? fmt2.format(areaM2()) + ' m²' : fmt1.format(areaM2() * SQFT_PER_M2) + ' sq ft';
    }
    function minAreaLabel() {
      return state.unit === 'cm' ? fmt2.format(minAreaM2) + ' m²' : fmt1.format(minAreaM2 * SQFT_PER_M2) + ' sq ft';
    }
    function cheapest() {
      var avail = variants.filter(function (v) { return v.available; });
      avail.sort(function (a, b) { return a.price - b.price; });
      return avail[0] || variants[0];
    }
    function qty() { return Math.max(1, minQty, Math.round(areaM2() * 10)); }
    function minApplied() { return minQty > 0 && Math.round(areaM2() * 10) < minQty; }
    function totalFor(v) { return qty() * v.price; }
    function compareTotalFor(v) { return v.compare > v.price ? qty() * v.compare : 0; }
    function unitPriceLabel(v) {
      if (state.unit === 'cm') return money(v.price * 10) + ' / m²';
      return money((v.price * 10) / SQFT_PER_M2) + ' / sq ft';
    }
    function minNoteText() {
      var val = state.unit === 'cm' ? fmt2.format(minAreaM2) + ' m²' : fmt1.format(minAreaM2 * SQFT_PER_M2);
      return (cfg.minOrderText || L.minOrder).replace('[sqft]', val);
    }

    var img = new Image();
    img.crossOrigin = 'anonymous';
    if (isTool) {
      img.src = rawFor();
      img.onload = function () { buildSrc(); drawCrop(); };
    }

    /* insan figürü silüeti (SVG asset) */
    var figImg = null;
    var figReady = false;
    if (isTool && cfg.figureUrl) {
      figImg = new Image();
      figImg.src = cfg.figureUrl;
      figImg.onload = function () { figReady = true; drawCrop(); };
    }

    /* flip/grayscale uygulanmış görseli offscreen'de hazırla — her sürüklemede
       değil, yalnızca toggle değişince yeniden üretilir */
    var srcCanvas = document.createElement('canvas');
    var srcCtx = srcCanvas.getContext('2d');
    var srcReady = false;
    function buildSrc() {
      if (!img.naturalWidth) return;
      srcCanvas.width = img.naturalWidth;
      srcCanvas.height = img.naturalHeight;
      srcCtx.setTransform(1, 0, 0, 1, 0, 0);
      srcCtx.clearRect(0, 0, srcCanvas.width, srcCanvas.height);
      srcCtx.filter = state.grayscale ? 'grayscale(1)' : 'none';
      if (state.flip) {
        srcCtx.translate(srcCanvas.width, 0);
        srcCtx.scale(-1, 1);
      }
      srcCtx.drawImage(img, 0, 0);
      srcCtx.setTransform(1, 0, 0, 1, 0, 0);
      srcCtx.filter = 'none';
      srcReady = true;
    }

    /* ---------- kırpma ---------- */
    function cropFrac() {
      if (!img.naturalWidth || !state.wCm || !state.hCm) return { fw: 1, fh: 1 };
      var imgA = img.naturalWidth / img.naturalHeight;
      var wallA = state.wCm / state.hCm;
      if (wallA >= imgA) return { fw: 1, fh: imgA / wallA };
      return { fw: wallA / imgA, fh: 1 };
    }

    function clampCrop() {
      var f = cropFrac();
      state.fx = Math.min(Math.max(0, state.fx), 1 - f.fw);
      state.fy = Math.min(Math.max(0, state.fy), 1 - f.fh);
    }

    function centerCrop() {
      var f = cropFrac();
      state.fx = (1 - f.fw) / 2;
      state.fy = (1 - f.fh) / 2;
    }

    /* ---------- ölçü okuma ---------- */
    function readDims(srcEl) {
      var w = 0, h = 0, touched = false;
      fields.forEach(function (f) {
        if (srcEl && f.el !== srcEl) return;
        if (f.axis === 'w') w = fieldCm(f); else h = fieldCm(f);
      });
      // kaynak alan yalnızca bir ekseni taşır; diğer eksen state'ten gelir
      if (srcEl) {
        var src = fields.find(function (f) { return f.el === srcEl; });
        if (src.axis === 'w') h = state.hCm; else w = state.wCm;
      }
      fields.forEach(function (f) { if (fieldTouched(f)) touched = true; });

      state.valid = w >= minSideCm && w <= maxWCm && h >= minSideCm && h <= maxHCm;
      if (w > 0 || h > 0) {
        var changed = Math.abs(w - state.wCm) > 0.01 || Math.abs(h - state.hCm) > 0.01;
        state.wCm = w;
        state.hCm = h;
        if (changed && state.valid) centerCrop();
      }
      if (srcEl) syncFields(srcEl);
      render(touched);
    }

    fields.forEach(function (f) {
      [f.a, f.b].forEach(function (input) {
        if (!input) return;
        input.addEventListener('input', function () {
          /* yalnız rakam + ayraç; harf/simge girilmesin (type=number'ın kaybolan filtresi) */
          var clean = input.value.replace(/[^0-9.,]/g, '');
          if (clean !== input.value) {
            var pos = (input.selectionStart || 0) - (input.value.length - clean.length);
            input.value = clean;
            try { input.setSelectionRange(pos, pos); } catch (e) {}
          }
          readDims(f.el);
        });
        /* alandan çıkınca gösterimi normalize et → ayraç daima nokta */
        input.addEventListener('blur', function () {
          if (!input.value) return; // bilinçli boşaltmayı geri doldurma
          setFieldFromCm(f, f.axis === 'w' ? state.wCm : state.hCm);
        });
      });
    });

    /* Ölçü alanlarına götür: kaydır → kısa vurgu → genişlik alanına odaklan.
       (mobil sticky bar'daki toForm ile aynı his) */
    function focusSize() {
      var calcEl = root.querySelector('.calc');
      var firstInput = fields.length ? fields[0].a : null;
      if (calcEl) {
        if (calcEl.scrollIntoView) calcEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        calcEl.classList.remove('calc--nudge');
        void calcEl.offsetWidth; // animasyonu yeniden başlat
        calcEl.classList.add('calc--nudge');
        setTimeout(function () { calcEl.classList.remove('calc--nudge'); }, 1100);
      }
      setTimeout(function () {
        if (firstInput) { try { firstInput.focus({ preventScroll: true }); } catch (e) { firstInput.focus(); } }
      }, 420);
    }

    /* Ölçü yoksa araç sayfasını AÇMA — kullanıcıyı forma yönlendir. */
    if (elGoLink) {
      elGoLink.addEventListener('click', function (e) {
        if (state.valid) return; // hazır → normal gezinme
        e.preventDefault();
        focusSize();
      });
    }

    if (elUnit) {
      elUnit.addEventListener('change', function () {
        state.unit = elUnit.value;
        setFieldModes();
        fields.forEach(function (f) { setFieldFromCm(f, f.axis === 'w' ? state.wCm : state.hCm); });
        readDims(null);
      });
    }

    /* ---------- kırpma editörü çizimi ----------
       Model: duvar çerçevesi SABİT ve ortada; ham görsel arka planda hareket
       eder (Rebel Walls davranışı). state.fx/fy = kırpılan alt dikdörtgenin
       görsel içindeki sol-üst köşe oranı. */
    var view = { imgWcss: 1, imgHcss: 1 };

    /* ---------- panel planı: müşteri panel genişliği (Printho) ---------- */
    function panelPlan() {
      if (!state.valid) return null;
      var full = (state.variant && state.variant.panelCm) || cfg.panelWidthCm || 50;
      var ov = (state.variant && state.variant.overlapCm) || 0;
      var usable = Math.max(1, full - ov);
      var n = Math.max(1, Math.ceil((state.wCm - 0.01) / usable));
      var last = state.wCm - (n - 1) * usable;
      return { n: n, full: full, usable: usable, last: last };
    }
    function cmOrIn(v) {
      return state.unit === 'cm' ? Math.round(v) + ' cm' : fmt1.format(v / CM_PER_IN) + ' in';
    }
    function panelText(pp) {
      if (pp.n === 1) return L.panelOne(cmOrIn(state.wCm));
      var s = L.panelMany(pp.n, cmOrIn(pp.full));
      if (pp.last < pp.full - 0.5) s += L.panelLast + cmOrIn(pp.last);
      return s;
    }
    function panelProp(pp) {
      var s = pp.n + '×' + Math.round(pp.full);
      if (pp.n > 1 && pp.last < pp.full - 0.5) s = (pp.n - 1) + '×' + Math.round(pp.full) + ' + ' + Math.round(pp.last);
      return s + ' cm';
    }

    function drawCrop() {
      if (!canvas) return;
      if (modal && !modal.open) return;
      if (!state.valid) return;
      if (!img.complete || !img.naturalWidth) return;
      if (!srcReady) buildSrc();
      if (!srcReady) return;
      var box = canvas.parentElement;
      var stageW = box.clientWidth;
      if (!stageW) return;

      /* sahne yüksekliği duvar oranına göre adaptif: yatay duvarda kısalır,
         kare/dikey duvarda büyür — sahne ile kartlar arasında boşluk kalmaz */
      var isNarrow = window.innerWidth < 990;
      var mTopCss = state.ruler ? 26 : 12;
      var mLeftCss = state.ruler ? 30 : 12;
      var mRightCss = 34; /* sağda toplam yükseklik etiketi */
      var mBotCss = 30;   /* altta toplam genişlik etiketi */
      var frameWcss = stageW - mLeftCss - mRightCss;
      var frameHcss = frameWcss / (state.wCm / state.hCm);
      var maxStageH = Math.min(window.innerHeight * (isNarrow ? 0.55 : 0.68), 760);
      var stageH = Math.max(240, Math.min(frameHcss + mTopCss + mBotCss, maxStageH));
      stageH = Math.round(stageH);
      if (Math.abs(box.clientHeight - stageH) > 2) box.style.height = stageH + 'px';

      var dpr = window.devicePixelRatio || 1;

      canvas.style.width = stageW + 'px';
      canvas.style.height = stageH + 'px';
      canvas.width = Math.round(stageW * dpr);
      canvas.height = Math.round(stageH * dpr);
      var W = canvas.width, H = canvas.height;
      ctx.clearRect(0, 0, W, H);

      /* çerçeve yerleşimi — üst/sol cetvel, alt/sağ toplam ölçü payı */
      var mTop = mTopCss * dpr;
      var mLeft = mLeftCss * dpr;
      var mRight = mRightCss * dpr, mBot = mBotCss * dpr;
      var availW = W - mLeft - mRight, availH = H - mTop - mBot;
      var wallA = state.wCm / state.hCm;
      var FW, FH;
      if (availW / availH > wallA) { FH = availH; FW = FH * wallA; }
      else { FW = availW; FH = FW / wallA; }
      var cx = mLeft + (availW - FW) / 2;
      var cy = mTop + (availH - FH) / 2;
      var cw = FW, ch = FH;

      /* görseli çerçeveye göre yerleştir (kırpılan alt dikdörtgen çerçeveyi doldurur) */
      var f = cropFrac();
      var iw = srcCanvas.width, ih = srcCanvas.height;
      var scale = FW / (f.fw * iw);
      var drawW = iw * scale, drawH = ih * scale;
      var drawX = cx - (state.fx * iw) * scale;
      var drawY = cy - (state.fy * ih) * scale;
      view.imgWcss = drawW / dpr;
      view.imgHcss = drawH / dpr;
      ctx.drawImage(srcCanvas, drawX, drawY, drawW, drawH);

      /* çerçeve dışını beyaza solan gradientle ört */
      var dragging = !!drag;
      var near = dragging ? 0.2 : 0.5;
      var far = 0.98;
      function wash(x0, y0, x1, y1, gx0, gy0, gx1, gy1) {
        if (x1 - x0 < 1 || y1 - y0 < 1) return;
        var g = ctx.createLinearGradient(gx0, gy0, gx1, gy1);
        g.addColorStop(0, 'rgba(255,255,255,' + near + ')');
        g.addColorStop(1, 'rgba(255,255,255,' + far + ')');
        ctx.fillStyle = g;
        ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
      }
      wash(0, 0, cx, H, cx, 0, 0, 0);
      wash(cx + cw, 0, W, H, cx + cw, 0, W, 0);
      wash(cx, 0, cx + cw, cy, 0, cy, 0, 0);
      wash(cx, cy + ch, cx + cw, H, 0, cy + ch, 0, H);

      /* panel çizgileri — seçili malzemenin PANEL genişliği (Printho metafield), bindirme düşülür;
         numaralı paneller + özet rozeti. Tek Parça Tekstil (320 cm) çoğu duvarda tek panel. */
      if (state.panels) {
        var pp = panelPlan();
        if (pp) {
          ctx.strokeStyle = 'rgba(92, 107, 83, 0.8)';
          ctx.lineWidth = 1 * dpr;
          ctx.font = '600 ' + (10 * dpr) + 'px "Hanken Grotesk", system-ui, sans-serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          for (var pi = 0; pi < pp.n; pi++) {
            var px0 = cx + (pi * pp.usable / state.wCm) * cw;
            var px1 = Math.min(cx + cw, cx + ((pi + 1) * pp.usable / state.wCm) * cw);
            if (pi > 0) { ctx.beginPath(); ctx.moveTo(px0, cy); ctx.lineTo(px0, cy + ch); ctx.stroke(); }
            if (pp.n > 1 && px1 - px0 > 22 * dpr) {
              var lx = (px0 + px1) / 2, ly = cy + 14 * dpr;
              ctx.fillStyle = 'rgba(255,255,255,0.85)';
              ctx.beginPath(); ctx.arc(lx, ly, 8 * dpr, 0, Math.PI * 2); ctx.fill();
              ctx.fillStyle = 'rgba(92, 107, 83, 1)';
              ctx.fillText(String(pi + 1), lx, ly);
            }
          }
          /* özet rozeti: sol-alt köşe, çerçevenin içinde */
          var txt = panelText(pp);
          var tw = ctx.measureText(txt).width + 12 * dpr, th = 16 * dpr;
          var bx = cx + 6 * dpr, by = cy + ch - th - 6 * dpr;
          ctx.fillStyle = 'rgba(28,27,24,0.72)';
          ctx.fillRect(bx, by, tw, th);
          ctx.fillStyle = '#fff';
          ctx.textAlign = 'left';
          ctx.fillText(txt, bx + 6 * dpr, by + th / 2);
          ctx.textAlign = 'left';
          ctx.textBaseline = 'alphabetic';
        }
      }

      if (state.figure) drawFigure(cx, cy, cw, ch, dpr);

      /* duvar sınırı: kesikli çizgi */
      ctx.setLineDash([6 * dpr, 4 * dpr]);
      ctx.strokeStyle = 'rgba(28, 27, 24, 0.85)';
      ctx.lineWidth = 1.5 * dpr;
      ctx.strokeRect(cx, cy, cw, ch);
      ctx.setLineDash([]);

      /* köşe crop işaretleri */
      ctx.strokeStyle = 'rgba(28, 27, 24, 0.9)';
      ctx.lineWidth = 1.5 * dpr;
      var L = 14 * dpr, O = 4 * dpr;
      [[cx, cy, -1, -1], [cx + cw, cy, 1, -1], [cx, cy + ch, -1, 1], [cx + cw, cy + ch, 1, 1]].forEach(function (k) {
        var ox = k[0] + k[2] * O, oy = k[1] + k[3] * O;
        ctx.beginPath();
        ctx.moveTo(ox + k[2] * L, oy); ctx.lineTo(ox, oy); ctx.lineTo(ox, oy + k[3] * L);
        ctx.stroke();
      });

      if (state.ruler) drawRuler(cx, cy, cw, ch, dpr);

      drawTotals(cx, cy, cw, ch, dpr);
    }

    /* altta toplam genişlik, sağda toplam yükseklik — mimari ölçü çizgisi */
    function drawTotals(cx, cy, cw, ch, dpr) {
      var off = 14 * dpr;
      var tick = 4 * dpr;
      var fs = 10.5 * dpr;
      ctx.strokeStyle = 'rgba(28,27,24,0.5)';
      ctx.lineWidth = 1 * dpr;
      ctx.font = '600 ' + fs + 'px "Hanken Grotesk", system-ui, sans-serif';

      function pill(x, y, text, rotate) {
        var tw = ctx.measureText(text).width;
        var pw = tw + 14 * dpr;
        var ph = fs + 9 * dpr;
        ctx.save();
        ctx.translate(x, y);
        if (rotate) ctx.rotate(-Math.PI / 2);
        ctx.fillStyle = 'rgba(255,255,255,0.95)';
        ctx.beginPath();
        if (ctx.roundRect) ctx.roundRect(-pw / 2, -ph / 2, pw, ph, 3 * dpr);
        else ctx.rect(-pw / 2, -ph / 2, pw, ph);
        ctx.fill();
        ctx.strokeStyle = 'rgba(28,27,24,0.2)';
        ctx.stroke();
        ctx.fillStyle = 'rgba(28,27,24,0.85)';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, 0, 1 * dpr);
        ctx.restore();
        ctx.textAlign = 'start';
        ctx.textBaseline = 'alphabetic';
        ctx.strokeStyle = 'rgba(28,27,24,0.5)';
      }

      /* alt: toplam genişlik */
      var by = cy + ch + off;
      ctx.beginPath();
      ctx.moveTo(cx, by); ctx.lineTo(cx + cw, by);
      ctx.moveTo(cx, by - tick); ctx.lineTo(cx, by + tick);
      ctx.moveTo(cx + cw, by - tick); ctx.lineTo(cx + cw, by + tick);
      ctx.stroke();
      pill(cx + cw / 2, by, dimLabelOne(state.wCm), false);

      /* sağ: toplam yükseklik */
      var rx = cx + cw + off;
      ctx.beginPath();
      ctx.moveTo(rx, cy); ctx.lineTo(rx, cy + ch);
      ctx.moveTo(rx - tick, cy); ctx.lineTo(rx + tick, cy);
      ctx.moveTo(rx - tick, cy + ch); ctx.lineTo(rx + tick, cy + ch);
      ctx.stroke();
      pill(rx, cy + ch / 2, dimLabelOne(state.hCm), true);
    }

    function figureLabel(figCm) {
      if (state.unit === 'cm') return Math.round(figCm) + ' cm';
      var totalIn = figCm / CM_PER_IN;
      var ft = Math.floor(totalIn / 12);
      var rem = Math.round(totalIn - ft * 12);
      if (rem >= 12) { ft += 1; rem = 0; }
      return ft + "'" + rem + '"';
    }

    function drawFigure(cx, cy, cw, ch, dpr) {
      if (!figReady || !figImg) return;
      var figCm = cfg.figureCm || 165;
      var aspect = figImg.naturalWidth && figImg.naturalHeight
        ? figImg.naturalWidth / figImg.naturalHeight
        : (37.82 / 137.6);
      /* Figür GERÇEK ölçekte kalır (165cm); mural daha kısaysa küçültülmez,
         ayaklar altta sabit kalıp ÜSTTEN kırpılır (duvar üstünde kesilir). */
      var HfFull = (figCm / state.hCm) * ch;
      var Wf = HfFull * aspect;
      if (Wf > cw * 0.6) return;
      /* duruş/arka ayak nedeniyle figür hafif aşağı basar (duvarın önünde durma hissi) */
      var stanceDrop = Math.min(HfFull * 0.065, 26 * dpr);
      var baseY = cy + ch + stanceDrop;
      var topFull = baseY - HfFull;         // figürün gerçek üst noktası
      var visTop = Math.max(topFull, cy);   // duvar üstünde kırp
      var visH = baseY - visTop;
      if (visH < 30 * dpr) return;
      var X = cx + cw - Wf / 2 - Math.max(20 * dpr, Wf * 0.5);
      X = Math.max(X, cx + Wf / 2 + 6 * dpr);

      var nW = figImg.naturalWidth || 1, nH = figImg.naturalHeight || 1;
      var cutFrac = (visTop - topFull) / HfFull;   // üstten kırpılan oran (0 = kırpma yok)
      ctx.drawImage(figImg, 0, nH * cutFrac, nW, nH * (visH / HfFull), X - Wf / 2, visTop, Wf, visH);

      /* boy etiketi — görünen gövdeye sığıyorsa çiz */
      var flbl = figureLabel(figCm);
      var ffs = 10 * dpr;
      ctx.font = '600 ' + ffs + 'px "Hanken Grotesk", system-ui, sans-serif';
      if (ctx.measureText(flbl).width + 8 * dpr < Wf) {
        ctx.fillStyle = 'rgba(255,255,255,0.92)';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(flbl, X, baseY - visH * 0.5);
        ctx.textAlign = 'start';
        ctx.textBaseline = 'alphabetic';
      }
    }

    function rulerLabel(vcm) {
      if (state.unit === 'cm') return Math.round(vcm) + ' cm';
      var vin = vcm / CM_PER_IN;
      if (state.unit === 'ftin') return Math.round(vin / 12) + ' ft';
      return Math.round(vin) + ' in';
    }

    function drawRuler(cx, cy, cw, ch, dpr) {
      var majCm = state.unit === 'cm' ? 50 : 12 * CM_PER_IN;
      var minCm = state.unit === 'cm' ? 10 : 2 * CM_PER_IN;
      ctx.strokeStyle = 'rgba(28,27,24,0.5)';
      ctx.fillStyle = 'rgba(28,27,24,0.72)';
      ctx.lineWidth = 1 * dpr;
      ctx.font = '600 ' + (9 * dpr) + 'px "Hanken Grotesk", system-ui, sans-serif';
      ctx.textBaseline = 'alphabetic';
      ctx.textAlign = 'left';

      var mv;
      for (mv = 0; mv <= state.wCm + 0.1; mv += minCm) {
        var xm = cx + (mv / state.wCm) * cw;
        ctx.beginPath(); ctx.moveTo(xm, cy); ctx.lineTo(xm, cy - 4 * dpr); ctx.stroke();
      }
      for (mv = 0; mv <= state.wCm + 0.1; mv += majCm) {
        var xM = cx + (mv / state.wCm) * cw;
        ctx.beginPath(); ctx.moveTo(xM, cy); ctx.lineTo(xM, cy - 9 * dpr); ctx.stroke();
        if (xM + 24 * dpr < cx + cw) ctx.fillText(rulerLabel(mv), xM + 3 * dpr, cy - 12 * dpr);
      }
      for (mv = 0; mv <= state.hCm + 0.1; mv += minCm) {
        var ym = cy + ch - (mv / state.hCm) * ch;
        ctx.beginPath(); ctx.moveTo(cx, ym); ctx.lineTo(cx - 4 * dpr, ym); ctx.stroke();
      }
      for (mv = 0; mv <= state.hCm + 0.1; mv += majCm) {
        var yM = cy + ch - (mv / state.hCm) * ch;
        ctx.beginPath(); ctx.moveTo(cx, yM); ctx.lineTo(cx - 9 * dpr, yM); ctx.stroke();
        if (yM - 24 * dpr > cy) {
          ctx.save();
          ctx.translate(cx - 12 * dpr, yM);
          ctx.rotate(-Math.PI / 2);
          ctx.fillText(rulerLabel(mv), 3 * dpr, 3 * dpr);
          ctx.restore();
        }
      }
      ctx.textAlign = 'start';
    }

    /* toolbar toggle'ları */
    toolBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.cfgToggle;
        state[key] = !state[key];
        btn.setAttribute('aria-pressed', String(state[key]));
        if (key === 'flip' || key === 'grayscale') buildSrc();
        drawCrop();
      });
    });

    var drag = null;
    var dragChip = $('[data-cfg-dragchip]');
    if (canvas) {
      canvas.style.touchAction = 'none';
      canvas.addEventListener('pointerdown', function (e) {
        if (dragChip && !dragChip.hidden) dragChip.hidden = true;
        drag = { px: e.clientX, py: e.clientY, x0: state.fx, y0: state.fy };
        canvas.setPointerCapture(e.pointerId);
        canvas.classList.add('is-dragging');
        drawCrop();
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!drag) return;
        state.fx = drag.x0 - (e.clientX - drag.px) / view.imgWcss;
        state.fy = drag.y0 - (e.clientY - drag.py) / view.imgHcss;
        clampCrop();
        drawCrop();
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        canvas.addEventListener(ev, function () {
          drag = null;
          canvas.classList.remove('is-dragging');
          drawCrop();
        });
      });
      window.addEventListener('resize', drawCrop);
    }

    var dragChipClose = $('[data-cfg-dragchip-close]');
    if (dragChipClose && dragChip) {
      dragChipClose.addEventListener('click', function () { dragChip.hidden = true; });
    }

    /* reset: kırpma merkeze, flip/grayscale kapalı, katmanlar varsayılana */
    var resetBtn = $('[data-cfg-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        centerCrop();
        state.flip = false;
        state.grayscale = false;
        state.ruler = layerDefaults.ruler;
        state.panels = layerDefaults.panels;
        state.figure = layerDefaults.figure;
        toolBtns.forEach(function (btn) {
          btn.setAttribute('aria-pressed', String(!!state[btn.dataset.cfgToggle]));
        });
        buildSrc();
        render(true);
      });
    }

    var noteToggle = $('[data-cfg-note-toggle]');
    var noteWrap = $('[data-cfg-note-wrap]');
    if (noteToggle && noteWrap) {
      noteToggle.addEventListener('click', function () {
        noteWrap.hidden = !noteWrap.hidden;
        if (!noteWrap.hidden) noteWrap.querySelector('textarea').focus();
      });
    }

    /* ---------- malzeme kartları ---------- */
    var infoModal = $('[data-cfg-info]');

    /* Etiket satırı: varyant metafield (Printho) → tema ayarı; maddeler = material_desc satırları (ilk satır etiket DEĞİL). */
    function matMeta(v) {
      var lines = (v.desc || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
      return { tag: v.mtag || v.tag || '', bullets: lines, text: v.text || '' };
    }

    var infoV = null;
    function selectVariant(v) {
      if (!v || !v.available) return;
      state.variant = v;
      if (elMaterials) elMaterials.querySelectorAll('.cfg-mat').forEach(function (el) {
        el.setAttribute('aria-checked', String(el._variant === v));
      });
      if (elBarHint) elBarHint.hidden = true;
      render(true);
    }

    function openInfo(v) {
      if (!infoModal) return;
      infoV = v;
      var meta = matMeta(v);
      infoModal.querySelector('[data-cfg-info-name]').textContent = v.title;
      infoModal.querySelector('[data-cfg-info-tag]').textContent = meta.tag;
      var textEl = infoModal.querySelector('[data-cfg-info-text]');
      textEl.textContent = meta.text;
      textEl.hidden = !meta.text;
      infoModal.querySelector('[data-cfg-info-lines]').innerHTML = meta.bullets
        .map(function (l) { return '<li>' + escapeHtml(l.trim()) + '</li>'; })
        .join('');
      /* kare medya: video öncelik (varsa poster=görsel), yoksa görsel */
      var mediaEl = infoModal.querySelector('[data-cfg-info-media]');
      var imgEl = infoModal.querySelector('[data-cfg-info-img]');
      var vidEl = infoModal.querySelector('[data-cfg-info-video]');
      var hasVid = !!v.matVideo;
      var hasImg = !!v.matImg;
      if (mediaEl) {
        if (hasVid) {
          vidEl.src = v.matVideo;
          if (hasImg) vidEl.poster = v.matImg;
          vidEl.hidden = false;
          imgEl.hidden = true;
          imgEl.removeAttribute('src');
        } else if (hasImg) {
          imgEl.src = v.matImg;
          imgEl.alt = v.title;
          imgEl.hidden = false;
          vidEl.hidden = true;
          vidEl.removeAttribute('src');
        }
        mediaEl.hidden = !(hasVid || hasImg);
      }
      /* alt bilgi: fiyat (ölçü girildiyse toplam, yoksa birim) + seç butonu */
      var priceEl = infoModal.querySelector('[data-cfg-info-price]');
      if (priceEl) {
        priceEl.innerHTML = state.valid
          ? '<strong>' + money(totalFor(v)) + '</strong> <span>' + unitPriceLabel(v) + '</span>'
          : '<span>' + unitPriceLabel(v) + '</span>';
      }
      var selBtn = infoModal.querySelector('[data-cfg-info-select]');
      if (selBtn) {
        var isSel = state.variant === v;
        selBtn.disabled = !v.available;
        selBtn.textContent = !v.available ? L.unavailable : (isSel ? L.selected : L.selectMat);
      }
      infoModal.showModal();
    }
    if (infoModal) {
      var infoVid = infoModal.querySelector('[data-cfg-info-video]');
      function stopInfoVid() { if (infoVid && !infoVid.hidden) { try { infoVid.pause(); } catch (e) {} } }
      infoModal.querySelector('[data-cfg-info-close]').addEventListener('click', function () { infoModal.close(); });
      infoModal.addEventListener('click', function (e) {
        if (e.target === infoModal) infoModal.close();
      });
      infoModal.addEventListener('close', stopInfoVid);
      var infoSelBtn = infoModal.querySelector('[data-cfg-info-select]');
      if (infoSelBtn) infoSelBtn.addEventListener('click', function () {
        selectVariant(infoV);
        infoModal.close();
      });
    }

    /* ---------- Compare materials (3'ü yan yana) ---------- */
    var compareModal = $('[data-cfg-compare]');
    var compareOpenBtn = $('[data-cfg-compare-open]');
    function escapeAttr(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function updateCompareTotals() {
      if (!compareModal) return;
      variants.forEach(function (v) {
        var el = compareModal.querySelector('[data-cfg-cmp-total="' + v.id + '"]');
        if (!el) return;
        el.innerHTML = state.valid
          ? '<strong>' + money(totalFor(v)) + '</strong> <span>' + unitPriceLabel(v) + '</span>'
          : '<span>' + unitPriceLabel(v) + '</span>';
      });
    }
    function mediaHtml(v) {
      if (v.matVideo) {
        return '<video class="cfg-cmp__media" src="' + escapeAttr(v.matVideo) + '"' +
          (v.matImg ? ' poster="' + escapeAttr(v.matImg) + '"' : '') +
          ' playsinline muted loop controls preload="metadata"></video>';
      }
      if (v.matImg) {
        return '<img class="cfg-cmp__media" src="' + escapeAttr(v.matImg) + '" alt="' + escapeHtml(v.title) + '" loading="lazy">';
      }
      return '<div class="cfg-cmp__media cfg-cmp__media--empty" aria-hidden="true"></div>';
    }
    function buildCompare() {
      var grid = compareModal && compareModal.querySelector('[data-cfg-compare-grid]');
      if (!grid) return;
      grid.style.setProperty('--cmp-cols', String(variants.length));
      var panelLabel = grid.getAttribute('data-cfg-cmp-panel-label') || 'Panel width';
      grid.innerHTML = variants.map(function (v) {
        var meta = matMeta(v);
        var spec = v.panelCm ? '<div class="cfg-cmp__spec"><span>' + escapeHtml(panelLabel) + '</span><strong>' + v.panelCm + ' cm</strong></div>' : '';
        var lines = meta.bullets.length
          ? '<ul class="cfg-cmp__lines">' + meta.bullets.map(function (l) { return '<li>' + escapeHtml(l.trim()) + '</li>'; }).join('') + '</ul>'
          : (meta.text ? '<p class="cfg-cmp__text">' + escapeHtml(meta.text) + '</p>' : '');
        var selLabel = !v.available ? L.unavailable : (state.variant === v ? L.selected : L.selectMat);
        /* 5 tutarlı çocuk (fig/name/tag/body/foot) → CSS subgrid ile satırlar
           sütunlar arası hizalanır (karşılaştırma için). tag/body boş da olsa var. */
        return '<div class="cfg-cmp">' +
          '<figure class="cfg-cmp__fig">' + mediaHtml(v) + '</figure>' +
          '<div class="cfg-cmp__name">' + escapeHtml(v.title) + '</div>' +
          '<div class="cfg-cmp__tag">' + (meta.tag ? escapeHtml(meta.tag) : '') + '</div>' +
          '<div class="cfg-cmp__body">' + spec + lines + '</div>' +
          '<div class="cfg-cmp__foot">' +
            '<div class="cfg-cmp__total" data-cfg-cmp-total="' + v.id + '"></div>' +
            '<button type="button" class="cfg-cmp__select" data-cfg-cmp-select="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + selLabel + '</button>' +
          '</div>' +
        '</div>';
      }).join('');
    }
    if (compareModal && compareOpenBtn && variants.length >= 2) {
      compareOpenBtn.hidden = false;
      function stopCompareVids() {
        compareModal.querySelectorAll('video').forEach(function (vd) { try { vd.pause(); } catch (e) {} });
      }
      compareOpenBtn.addEventListener('click', function () {
        buildCompare();
        updateCompareTotals();
        compareModal.showModal();
      });
      compareModal.querySelector('[data-cfg-compare-close]').addEventListener('click', function () { compareModal.close(); });
      compareModal.addEventListener('click', function (e) { if (e.target === compareModal) compareModal.close(); });
      compareModal.addEventListener('close', stopCompareVids);
      /* kart içindeki "Select" butonları (delegation) — seç + modalı kapat */
      var cmpGrid = compareModal.querySelector('[data-cfg-compare-grid]');
      if (cmpGrid) cmpGrid.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-cfg-cmp-select]');
        if (!btn) return;
        var id = btn.getAttribute('data-cfg-cmp-select');
        var v = variants.filter(function (x) { return String(x.id) === id; })[0];
        if (v) { selectVariant(v); compareModal.close(); }
      });
    }

    function buildMaterialCards() {
    if (!elMaterials) return;
    elMaterials.innerHTML = '';
    variants.forEach(function (v) {
      var card = document.createElement('div');
      card.className = 'cfg-mat';
      card.setAttribute('role', 'radio');
      card.setAttribute('aria-checked', 'false');
      card.setAttribute('tabindex', v.available ? '0' : '-1');
      if (!v.available) card.setAttribute('aria-disabled', 'true');

      var meta = matMeta(v);
      var tag = meta.tag;
      var hasInfo = !!(meta.text || meta.bullets.length);

      card.innerHTML =
        (v.image ? '<img class="cfg-mat__img" src="' + v.image + '" alt="" loading="lazy">' : '') +
        '<span class="cfg-mat__body">' +
          '<span class="cfg-mat__namerow">' +
            '<span class="cfg-mat__name">' + escapeHtml(v.title) + '</span>' +
            (hasInfo ? '<button type="button" class="cfg-mat__info" data-cfg-mat-info aria-label="' + escapeHtml(L.matDetails(v.title)) + '" title="' + escapeHtml(L.matDetailsTitle) + '">i</button>' : '') +
          '</span>' +
          (tag ? '<span class="cfg-mat__tag">' + escapeHtml(tag) + '</span>' : '') +
        '</span>' +
        '<span class="cfg-mat__pricecol">' +
          '<span class="cfg-mat__total" data-cfg-mat-total>—</span>' +
          '<del class="cfg-mat__compare" data-cfg-mat-compare hidden></del>' +
          '<span class="cfg-mat__unit" data-cfg-mat-unit></span>' +
          '<span class="cfg-mat__check" aria-hidden="true">&#10003;</span>' +
        '</span>';

      function select() { selectVariant(v); }

      card.addEventListener('click', select);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          select();
        }
      });

      var infoBtn = card.querySelector('[data-cfg-mat-info]');
      if (infoBtn) {
        infoBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          openInfo(v);
        });
      }

      card._variant = v;
      elMaterials.appendChild(card);
    });
    }
    buildMaterialCards();

    /* Renk seçimi: kartlar/karşılaştırma yeniden kurulur, aynı malzeme yeni renkte seçili kalır,
       galeri ana görseli ve (duvar aracında) crop görseli o renge geçer, numune seçimi filtrelenir. */
    var colorBtns = root.querySelectorAll('[data-color-picker] [data-color]');
    function updateGoLink() {
      if (!elGoLink || !activeColor) return;
      var base = elGoLink.getAttribute('data-base') || elGoLink.getAttribute('href') || '';
      base = base.replace(/([?&])color=[^&]*&?/, '$1').replace(/[?&]$/, '');
      elGoLink.setAttribute('data-base', base + (base.indexOf('?') >= 0 ? '&' : '?') + 'color=' + encodeURIComponent(activeColor));
    }
    function syncSampleSelect() {
      var ss = root.querySelector('[data-sample-select]');
      if (!ss || !activeColor) return;
      var first = null;
      Array.prototype.forEach.call(ss.options, function (o) {
        var oc = o.getAttribute('data-color');
        var ok = !oc || oc === activeColor;
        o.hidden = !ok;
        o.disabled = !ok || o.hasAttribute('data-unavail');
        if (ok && !o.disabled && !first) first = o;
      });
      if (first && ss.value !== first.value) { ss.value = first.value; ss.dispatchEvent(new Event('change')); }
    }
    function setColor(c, init) {
      if (!c || colors.indexOf(c) < 0) return;
      if (!init && c === activeColor) return;
      activeColor = c;
      colorBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-color') === c)); });
      variants = byColor();
      if (!init) {
        var prevTitle = state.variant ? state.variant.title : null;
        state.variant = null;
        buildMaterialCards();
        buildCompare();
        var same = prevTitle ? variants.filter(function (v) { return v.title === prevTitle && v.available; })[0] : null;
        if (same) selectVariant(same); else render(true);
        var gi = root.querySelector('[data-gallery-main] img');
        var cv = variants.filter(function (v) { return v.colorImage; })[0];
        if (gi && cv) { gi.src = cv.colorImage; gi.removeAttribute('srcset'); }
        if (isTool) img.src = rawFor();
      }
      syncSampleSelect();
      updateGoLink();
    }
    colorBtns.forEach(function (b) { b.addEventListener('click', function () { setColor(b.getAttribute('data-color')); }); });
    if (activeColor) setColor(activeColor, true);

    function escapeHtml(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }

    /* ---------- modal (yalnızca modal modunda) ---------- */
    if (elOpen && modal) {
      elOpen.addEventListener('click', function () {
        if (!state.valid) {
          if (elHelp) { elHelp.innerHTML = rangeText(); elHelp.classList.add('is-warn'); }
          fields[0].a.focus();
          return;
        }
        modal.showModal();
        requestAnimationFrame(drawCrop);
      });
      var closeBtn = $('[data-cfg-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.close();
      });
    }

    if (elAddWrap) {
      elAddWrap.addEventListener('click', function () {
        if (elAdd.disabled) {
          if (elBarHint) elBarHint.hidden = false;
          if (elMaterials) {
            elMaterials.classList.add('is-nudge');
            setTimeout(function () { elMaterials.classList.remove('is-nudge'); }, 600);
          }
        }
      });
    }

    /* ---------- görünüm ---------- */
    function render(touched) {
      if (elHelp) {
        elHelp.innerHTML = state.valid || !touched ? helpDefault : rangeText();
        elHelp.classList.toggle('is-warn', !state.valid && !!touched);
      }
      if (elHelpM) elHelpM.textContent = state.valid ? '' : rangeText();

      var showMin = state.valid && minApplied();
      if (elMinNote) {
        elMinNote.hidden = !showMin;
        if (showMin) elMinNote.textContent = minNoteText();
      }

      /* malzeme kartları (araç modu) */
      if (state.valid && elMaterials) {
        elMaterials.querySelectorAll('.cfg-mat').forEach(function (el) {
          el.querySelector('[data-cfg-mat-total]').textContent = money(totalFor(el._variant));
          var mc = el.querySelector('[data-cfg-mat-compare]');
          var mcv = compareTotalFor(el._variant);
          mc.hidden = !mcv;
          if (mcv) mc.textContent = money(mcv);
          el.querySelector('[data-cfg-mat-unit]').textContent = '(' + unitPriceLabel(el._variant) + ')';
        });
      }

      var hasSel = !!state.variant && state.valid;

      /* satın alma butonu: durum etiketli, fiyat butonun içinde */
      if (elAdd) {
        if (!state.valid) {
          elAdd.disabled = true;
          elAdd.textContent = elAdd.dataset.labelSize || L.enterSize;
        } else if (!hasSel) {
          elAdd.disabled = true;
          elAdd.textContent = elAdd.dataset.labelMat || L.pickMat;
        } else {
          elAdd.disabled = false;
          setTick(elAdd, L.addToCart);
        }
      }

      /* "Your Mural" özet bloğu (araç modu) — ölçü + alan tek satırda */
      if (elSumDims) elSumDims.textContent = state.valid ? dimsLabel() + ' / ' + areaLabel() : sumDimsDefault;
      if (elSumArea) {
        /* alan artık ölçü satırında; ayrı satır yalnız min-fatura notu için */
        elSumArea.hidden = !(state.valid && showMin);
        if (state.valid && showMin) elSumArea.textContent = L.billedAt(minAreaLabel());
      }
      if (elSumMat) elSumMat.textContent = hasSel ? state.variant.title : sumMatDefault;

      /* final fiyat — malzeme seçilince özet bloğunda büyük görünür */
      if (elSumTotal) {
        elSumTotal.hidden = !hasSel;
        if (hasSel) {
          setTick(elSumTotalAmt, money(totalFor(state.variant)));
          var tcmp = compareTotalFor(state.variant);
          if (elSumTotalCmp) {
            elSumTotalCmp.hidden = !tcmp;
            if (tcmp) elSumTotalCmp.textContent = money(tcmp);
          }
        }
      }

      if (elSumSave) {
        var saveC = hasSel ? compareTotalFor(state.variant) : 0;
        if (saveC) {
          var saveAmt = saveC - totalFor(state.variant);
          var savePct = Math.round((saveAmt / saveC) * 100);
          elSumSave.hidden = false;
          elSumSave.textContent = L.youSave(money(saveAmt), savePct);
        } else {
          elSumSave.hidden = true;
        }
      }

      /* özet satırı (araç modu) */
      if (elBarTotal) elBarTotal.hidden = !hasSel;
      if (elBarDims) elBarDims.textContent = state.valid
        ? dimsLabel() + ' · ' + areaLabel() + (showMin ? ' · ' + L.billedTail(minAreaLabel()) : '')
        : '—';
      if (elBarMat) {
        if (hasSel) {
          elBarMat.textContent = state.variant.title;
          if (elBarTotal) setTick(elBarTotal, money(totalFor(state.variant)));
          var bcv = compareTotalFor(state.variant);
          if (elBarCompare) {
            elBarCompare.hidden = !bcv;
            if (bcv) elBarCompare.textContent = money(bcv);
          }
        } else {
          elBarMat.textContent = pickText;
          if (elBarCompare) elBarCompare.hidden = true;
        }
      }

      /* ana fiyat satırı — "From birim" ↔ "toplam" (ürün sayfası, lite modu) */
      if (elPriceWrap && priceDefault) {
        if (!state.valid) {
          elPriceWrap.classList.remove('is-total');
          elPricePrefix.hidden = false;
          elPricePrefix.textContent = priceDefault.prefix;
          setTick(elPriceAmount, priceDefault.amount);
          elPriceSuffix.textContent = priceDefault.suffix;
          if (elPriceCompare) {
            elPriceCompare.hidden = priceDefault.compareHidden;
            elPriceCompare.textContent = priceDefault.compare;
          }
        } else {
          elPriceWrap.classList.add('is-total');
          var tail = showMin ? areaLabel() + ' · ' + L.billedTail(minAreaLabel()) : areaLabel();
          var cmp = compareTotalFor(cheapest());
          if (elPriceCompare) {
            elPriceCompare.hidden = !cmp;
            if (cmp) elPriceCompare.textContent = money(cmp);
          }
          /* "Estimated from": malzeme HENÜZ seçilmedi → bu kesin toplam değil,
             en ucuz malzemeye göre tahmin. "From" tek başına bunu söylemiyordu. */
          elPricePrefix.hidden = false;
          elPricePrefix.textContent = L.estFrom;
          setTick(elPriceAmount, money(totalFor(cheapest())));
          /* Ayraç "·" METNE GÖMÜLMEZ → CSS'ten gelir (.is-total .unit::before).
             Mobilde alan alt satıra düştüğünde satır sarkan noktayla başlamasın. */
          elPriceSuffix.textContent = tail;
        }
      }

      /* ürün sayfası CTA linki → araç sayfasına ölçüyle git.
         cm TAM SAYIYA yuvarlanmaz: 56 in = 142,24 cm → 142'ye yuvarlanırsa araç
         sayfasında 142/2,54 = 55,9 olarak geri döner (±0,1 sapma). 3 ondalık,
         inch/ft-in girdilerinin tam gidiş-dönüşü için yeterli. */
      /* Ölçü girilmeden araç sayfası AÇILMAZ: buton "bekliyor" durumuna geçer,
         tıklanınca ölçü alanlarına götürür (mobil sticky bar ile aynı desen). */
      if (elGoLink) {
        var base = elGoLink.dataset.base || elGoLink.getAttribute('href');
        if (state.valid) {
          var linkW = Math.round(state.wCm * 1000) / 1000;
          var linkH = Math.round(state.hCm * 1000) / 1000;
          elGoLink.setAttribute('href', base + '&w=' + linkW + '&h=' + linkH + '&unit=' + state.unit);
          elGoLink.removeAttribute('aria-disabled');
          setText(elGoLink, goLinkLabel);
        } else {
          elGoLink.setAttribute('href', base);
          elGoLink.setAttribute('aria-disabled', 'true');
          setText(elGoLink, goLinkWaitLabel);
        }
      }

      clampCrop();
      drawCrop();
    }

    /* ---------- sepete ekleme ---------- */
    function setProp(form, name, value) {
      var input = form.querySelector('input[name="properties[' + name + ']"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        form.appendChild(input);
      }
      input.value = value;
    }

    function addToCart() {
      if (!state.valid || !state.variant) return;
      var form = document.getElementById(cfg.formId);
      if (!form) return;

      form.querySelector('input[name="id"]').value = state.variant.id;
      form.querySelector('input[name="quantity"]').value = qty();

      var f = cropFrac();
      var wCmR = Math.round(state.wCm);
      var hCmR = Math.round(state.hCm);
      var wInR = fmt1.format(state.wCm / CM_PER_IN);
      var hInR = fmt1.format(state.hCm / CM_PER_IN);
      var cmPart = wCmR + ' × ' + hCmR + ' cm';
      var pct = function (x) { return Math.round(x * 1000) / 10; };

      // Görünür sipariş boyutu: EN pazarında HER ZAMAN iki birim (inch bilgilendirme,
      // öne; cm işlevsel), müşterinin seçtiği görüntü biriminden bağımsız. TR yalnız cm.
      // (Üretim bu satırı OKUMAZ — aşağıdaki gizli _Size (cm) makine-okunur kaynaktır.)
      setProp(form, L.pSize, L.sizeInches ? wInR + ' × ' + hInR + ' in  ·  ' + cmPart : cmPart);
      setProp(form, L.pArea, areaLabel());
      if (minApplied()) {
        setProp(form, L.pBilling, L.billingMin(minAreaLabel()));
      }
      setProp(form, '_Size (cm)', wCmR + ' × ' + hCmR); // ÜRETİM (işlevsel) — makine-okunur cm
      setProp(form, '_Print size (cm)', (wCmR + cfg.bleedCm) + ' × ' + (hCmR + cfg.bleedCm));
      var ppSubmit = panelPlan();
      if (ppSubmit) setProp(form, '_Panels', panelProp(ppSubmit)); // müşterinin gördüğü panel planı (duvar enine göre)
      setProp(form, '_Crop area (%)', 'x=' + pct(state.fx) + ', y=' + pct(state.fy) + ', w=' + pct(f.fw) + ', h=' + pct(f.fh));

      if (state.flip) setProp(form, L.pOrient, L.mirrored);
      if (state.grayscale) setProp(form, L.pColor, L.grayscale);

      var noteEl = $('[data-cfg-note]');
      if (noteEl && noteEl.value.trim()) {
        setProp(form, L.pNote, noteEl.value.trim());
      }

      if (modal && modal.open) modal.close();
      form.submit();
    }
    if (elAdd) elAdd.addEventListener('click', addToCart);

    /* araç sayfası: URL'den ölçü ön-doldur + yüklemede çiz */
    if (isTool) {
      try {
        var qs = new URLSearchParams(window.location.search);
        var qw = parseFloat(qs.get('w')), qh = parseFloat(qs.get('h')), qu = qs.get('unit');
        // Birim seçici gizliyse (TR: yalnız cm) URL'deki birim yok sayılır — seçicisiz inç gösterilmez.
        if (qu && elUnit && (qu === 'in' || qu === 'ftin' || qu === 'cm')) {
          state.unit = qu;
          if (elUnit) elUnit.value = qu;
        }
        setFieldModes();
        if (qw > 0 && qh > 0) {
          state.wCm = qw; state.hCm = qh;
          fields.forEach(function (f) { setFieldFromCm(f, f.axis === 'w' ? qw : qh); });
        }
      } catch (e) {}
      readDims(null);
      requestAnimationFrame(drawCrop);
      window.addEventListener('load', function () { drawCrop(); });
    } else {
      setFieldModes();
      render(false);
    }
  }

  function boot() {
    document.querySelectorAll('[data-stufic-pdp]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      initGallery(root);
      initConfigurator(root);
    });
    document.querySelectorAll('[data-stufic-tabs]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      initTabs(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
